import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { PageHeader, Card, Loading, CompStatus, DemoBadge } from "../../components/common";

export default function Clients() {
  const [rows, setRows] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/backoffice/companies").then((r) => setRows(r.data)); }, []);
  if (!rows) return <Loading />;
  return (
    <div>
      <PageHeader eyebrow="Backoffice DP" title="Clientes" subtitle="Empresas sob sua responsabilidade. Abra a visão 360º para dados, competência, solicitações e notas internas." />
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
        {rows.map((c) => (
          <button key={c.id} data-testid={`client-card-${c.id}`} onClick={() => nav(`/backoffice/clientes/${c.id}`)} className="card-surface card-hover p-5 text-left">
            <div className="flex items-start justify-between gap-3"><div><div className="font-semibold text-slate-900">{c.trade_name}</div><div className="text-xs text-slate-500 font-mono mt-0.5">{c.cnpj}</div></div>{c.demo && <DemoBadge />}</div>
            <div className="grid grid-cols-3 gap-3 mt-5">
              <div><div className="label-xs">Funcionários</div><div className="font-display text-xl font-semibold">{c.employees_active}</div></div>
              <div><div className="label-xs">Abertas</div><div className="font-display text-xl font-semibold">{c.open_requests}</div></div>
              <div><div className="label-xs">Atrasadas</div><div className={`font-display text-xl font-semibold ${c.overdue ? "text-rose-700" : ""}`}>{c.overdue}</div></div>
            </div>
            <div className="flex items-center justify-between mt-4 pt-4 border-t text-xs"><span className="text-slate-500">{c.status === "em_implantacao" ? `Em implantação · passo ${c.onboarding_step}/7` : `Resp.: ${c.responsible_dp_name || "—"}`}</span>{c.competencia_status && <CompStatus s={c.competencia_status} label={c.competencia_label} />}</div>
          </button>))}
      </div>
    </div>
  );
}
